import React, { Fragment } from 'react';
import classes from '../Nps.module.css';
import { Grid } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import ToolTip from '../../../components/Tooltip/Tooltip';

const TopEmpresas = props => {
	const { data } = props;

	let contentTop;
	let contentBottom;

	var last = function(data, n) {
		if (data == null) return void 0;
		if (n == null) return data[data.length - 1];
		return data.slice(Math.max(data.length - n, 0));
	};

	if (last(data)) {
		const lastAux = last(data, 10);
		const lastObject = lastAux.reverse();
		const firstObject = data.slice(0, 10);

		contentTop = firstObject.map(empresa => (
			<tr key={empresa.idEmpresa}>
				<td className={classes.td}>{empresa.idEmpresa}</td>
				<td className={classes.td}>{empresa.nombreEmpresa}</td>
				<td className={classes.td}>
					<NumberFormat value={empresa.scoreNps * 100} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={classes.td}>{empresa.nUsuarios}</td>
				<td className={classes.npsGreen}>{empresa.n9y10}</td>
				<td className={classes.npsYellow}>{empresa.n7y8}</td>
				<td className={classes.npsRed}>{empresa.n6}</td>
			</tr>
		));

		contentBottom = lastObject.map(empresa => (
			<tr key={empresa.idEmpresa}>
				<td className={classes.td}>{empresa.idEmpresa}</td>
				<td className={classes.td}>{empresa.nombreEmpresa}</td>
				<td className={classes.td}>
					<NumberFormat value={empresa.scoreNps * 100} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={classes.td}>{empresa.nUsuarios}</td>
				<td className={classes.npsGreen}>{empresa.n9y10}</td>
				<td className={classes.npsYellow}>{empresa.n7y8}</td>
				<td className={classes.npsRed}>{empresa.n6}</td>
			</tr>
		));
	}

	return (
		<Fragment>
			<Grid item xs={12}>
				<Grid container spacing={1}>
					<Grid item xs={6}>
						<div className={classes.card}>
							<ToolTip text={'Top Empresas del mes actual, ordenadas por cantidad de respuestas y respuestas mayores a 7.'} />
							<div>Top Empresas</div>
							<div className={classes.div}>
								<table className={classes.table}>
									<thead>
										<tr>
											<th>Id</th>
											<th>Empresa</th>
											<th>Score</th>
											<th>N</th>
											<th>>9</th>
											<th>7-8</th>
											<th>6</th>
										</tr>
									</thead>
									<tbody>{contentTop}</tbody>
								</table>
							</div>
						</div>
					</Grid>

					<Grid item xs={6}>
						<div className={classes.card}>
							<ToolTip text={'Empresas con puntaje más negativo y ordenadas por cantidad de respuestas menores 6.'} />
							<div>Bottom Empresas</div>
							<div className={classes.div}>
								<table className={classes.table}>
									<thead>
										<tr>
											<th>Id</th>
											<th>Empresa</th>
											<th>Score</th>
											<th>N</th>
											<th>>9</th>
											<th>7-8</th>
											<th>6</th>
										</tr>
									</thead>
									<tbody>{contentBottom}</tbody>
								</table>
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
};

export default React.memo(TopEmpresas);
